/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfListOfCurrentOrganizationDailyResellerStatisticsDto } from '../models/custom-result-of-list-of-current-organization-daily-reseller-statistics-dto';
import { CustomResultOfListOfCurrentOrganizationResellersStatisticsDto } from '../models/custom-result-of-list-of-current-organization-resellers-statistics-dto';
import { CustomResultOfListOfGetComplexStatisticsResult } from '../models/custom-result-of-list-of-get-complex-statistics-result';
import { CustomResultOfListOfGetCurrentDayStatisticsResult } from '../models/custom-result-of-list-of-get-current-day-statistics-result';
import { CustomResultOfListOfGetDailyStatisticsBySmsPartsDto } from '../models/custom-result-of-list-of-get-daily-statistics-by-sms-parts-dto';
import { CustomResultOfListOfGetDetailComplexStatisticsResult } from '../models/custom-result-of-list-of-get-detail-complex-statistics-result';
import { CustomResultOfListOfGetMonthlyStatisticsBySmsPartsDto } from '../models/custom-result-of-list-of-get-monthly-statistics-by-sms-parts-dto';
import { CustomResultOfListOfGetOperatorDailyStatisticsResult } from '../models/custom-result-of-list-of-get-operator-daily-statistics-result';
import { CustomResultOfListOfGetOperatorMonthlyStatisticsResult } from '../models/custom-result-of-list-of-get-operator-monthly-statistics-result';
import { CustomResultOfListOfGetSendCountDailyStatisticsResult } from '../models/custom-result-of-list-of-get-send-count-daily-statistics-result';
import { CustomResultOfListOfGetSendCountMonthlyStatisticsResult } from '../models/custom-result-of-list-of-get-send-count-monthly-statistics-result';
import { CustomResultOfListOfGetSendStatusDailyStatisticsResult } from '../models/custom-result-of-list-of-get-send-status-daily-statistics-result';
import { CustomResultOfListOfGetSendStatusMonthlyStatisticsResult } from '../models/custom-result-of-list-of-get-send-status-monthly-statistics-result';
import { CustomResultOfListOfGetTodayStatisticsByOperatorDto } from '../models/custom-result-of-list-of-get-today-statistics-by-operator-dto';
import { CustomResultOfListOfGetUsersSentCountDailyStatisticsDto } from '../models/custom-result-of-list-of-get-users-sent-count-daily-statistics-dto';
import { CustomResultOfListOfGetUsersSentCountMonthlyStatisticsDto } from '../models/custom-result-of-list-of-get-users-sent-count-monthly-statistics-dto';
import { statisticsGetComplexStatisticsByUserId } from '../fn/statistics/statistics-get-complex-statistics-by-user-id';
import { StatisticsGetComplexStatisticsByUserId$Params } from '../fn/statistics/statistics-get-complex-statistics-by-user-id';
import { statisticsGetCurrentOrganizationComplexStatistics } from '../fn/statistics/statistics-get-current-organization-complex-statistics';
import { StatisticsGetCurrentOrganizationComplexStatistics$Params } from '../fn/statistics/statistics-get-current-organization-complex-statistics';
import { statisticsGetCurrentOrganizationDailyResellersStatistics } from '../fn/statistics/statistics-get-current-organization-daily-resellers-statistics';
import { StatisticsGetCurrentOrganizationDailyResellersStatistics$Params } from '../fn/statistics/statistics-get-current-organization-daily-resellers-statistics';
import { statisticsGetCurrentOrganizationDailyStatisticsByPartLength } from '../fn/statistics/statistics-get-current-organization-daily-statistics-by-part-length';
import { StatisticsGetCurrentOrganizationDailyStatisticsByPartLength$Params } from '../fn/statistics/statistics-get-current-organization-daily-statistics-by-part-length';
import { statisticsGetCurrentOrganizationMonthlyResellersStatistics } from '../fn/statistics/statistics-get-current-organization-monthly-resellers-statistics';
import { StatisticsGetCurrentOrganizationMonthlyResellersStatistics$Params } from '../fn/statistics/statistics-get-current-organization-monthly-resellers-statistics';
import { statisticsGetCurrentOrganizationMonthlyStatisticsByPartLength } from '../fn/statistics/statistics-get-current-organization-monthly-statistics-by-part-length';
import { StatisticsGetCurrentOrganizationMonthlyStatisticsByPartLength$Params } from '../fn/statistics/statistics-get-current-organization-monthly-statistics-by-part-length';
import { statisticsGetCurrentOrganizationOperatorDailyStatistics } from '../fn/statistics/statistics-get-current-organization-operator-daily-statistics';
import { StatisticsGetCurrentOrganizationOperatorDailyStatistics$Params } from '../fn/statistics/statistics-get-current-organization-operator-daily-statistics';
import { statisticsGetCurrentOrganizationOperatorMonthlyStatistics } from '../fn/statistics/statistics-get-current-organization-operator-monthly-statistics';
import { StatisticsGetCurrentOrganizationOperatorMonthlyStatistics$Params } from '../fn/statistics/statistics-get-current-organization-operator-monthly-statistics';
import { statisticsGetCurrentOrganizationSendStatusDailyStatistics } from '../fn/statistics/statistics-get-current-organization-send-status-daily-statistics';
import { StatisticsGetCurrentOrganizationSendStatusDailyStatistics$Params } from '../fn/statistics/statistics-get-current-organization-send-status-daily-statistics';
import { statisticsGetCurrentOrganizationSendStatusMonthlyStatistics } from '../fn/statistics/statistics-get-current-organization-send-status-monthly-statistics';
import { StatisticsGetCurrentOrganizationSendStatusMonthlyStatistics$Params } from '../fn/statistics/statistics-get-current-organization-send-status-monthly-statistics';
import { statisticsGetCurrentOrganizationSentCountDailyStatistics } from '../fn/statistics/statistics-get-current-organization-sent-count-daily-statistics';
import { StatisticsGetCurrentOrganizationSentCountDailyStatistics$Params } from '../fn/statistics/statistics-get-current-organization-sent-count-daily-statistics';
import { statisticsGetCurrentOrganizationSentCountMonthlyStatistics } from '../fn/statistics/statistics-get-current-organization-sent-count-monthly-statistics';
import { StatisticsGetCurrentOrganizationSentCountMonthlyStatistics$Params } from '../fn/statistics/statistics-get-current-organization-sent-count-monthly-statistics';
import { statisticsGetCurrentOrganizationTodayStatistics } from '../fn/statistics/statistics-get-current-organization-today-statistics';
import { StatisticsGetCurrentOrganizationTodayStatistics$Params } from '../fn/statistics/statistics-get-current-organization-today-statistics';
import { statisticsGetCurrentUserComplexStatistics } from '../fn/statistics/statistics-get-current-user-complex-statistics';
import { StatisticsGetCurrentUserComplexStatistics$Params } from '../fn/statistics/statistics-get-current-user-complex-statistics';
import { statisticsGetCurrentUserDailyStatisticsByPartLength } from '../fn/statistics/statistics-get-current-user-daily-statistics-by-part-length';
import { StatisticsGetCurrentUserDailyStatisticsByPartLength$Params } from '../fn/statistics/statistics-get-current-user-daily-statistics-by-part-length';
import { statisticsGetCurrentUserDetailComplexStatistics } from '../fn/statistics/statistics-get-current-user-detail-complex-statistics';
import { StatisticsGetCurrentUserDetailComplexStatistics$Params } from '../fn/statistics/statistics-get-current-user-detail-complex-statistics';
import { statisticsGetCurrentUserMonthlyStatisticsByPartLength } from '../fn/statistics/statistics-get-current-user-monthly-statistics-by-part-length';
import { StatisticsGetCurrentUserMonthlyStatisticsByPartLength$Params } from '../fn/statistics/statistics-get-current-user-monthly-statistics-by-part-length';
import { statisticsGetCurrentUserOperatorDailyStatistics } from '../fn/statistics/statistics-get-current-user-operator-daily-statistics';
import { StatisticsGetCurrentUserOperatorDailyStatistics$Params } from '../fn/statistics/statistics-get-current-user-operator-daily-statistics';
import { statisticsGetCurrentUserOperatorMonthlyStatistics } from '../fn/statistics/statistics-get-current-user-operator-monthly-statistics';
import { StatisticsGetCurrentUserOperatorMonthlyStatistics$Params } from '../fn/statistics/statistics-get-current-user-operator-monthly-statistics';
import { statisticsGetCurrentUserSendStatusDailyStatistics } from '../fn/statistics/statistics-get-current-user-send-status-daily-statistics';
import { StatisticsGetCurrentUserSendStatusDailyStatistics$Params } from '../fn/statistics/statistics-get-current-user-send-status-daily-statistics';
import { statisticsGetCurrentUserSendStatusMonthlyStatistics } from '../fn/statistics/statistics-get-current-user-send-status-monthly-statistics';
import { StatisticsGetCurrentUserSendStatusMonthlyStatistics$Params } from '../fn/statistics/statistics-get-current-user-send-status-monthly-statistics';
import { statisticsGetCurrentUserSentCountDailyStatistics } from '../fn/statistics/statistics-get-current-user-sent-count-daily-statistics';
import { StatisticsGetCurrentUserSentCountDailyStatistics$Params } from '../fn/statistics/statistics-get-current-user-sent-count-daily-statistics';
import { statisticsGetCurrentUserSentCountMonthlyStatistics } from '../fn/statistics/statistics-get-current-user-sent-count-monthly-statistics';
import { StatisticsGetCurrentUserSentCountMonthlyStatistics$Params } from '../fn/statistics/statistics-get-current-user-sent-count-monthly-statistics';
import { statisticsGetCurrentUserTodayStatistics } from '../fn/statistics/statistics-get-current-user-today-statistics';
import { StatisticsGetCurrentUserTodayStatistics$Params } from '../fn/statistics/statistics-get-current-user-today-statistics';
import { statisticsGetDailyStatisticsByPartLengthByUserId } from '../fn/statistics/statistics-get-daily-statistics-by-part-length-by-user-id';
import { StatisticsGetDailyStatisticsByPartLengthByUserId$Params } from '../fn/statistics/statistics-get-daily-statistics-by-part-length-by-user-id';
import { statisticsGetDetailComplexStatisticsByUserId } from '../fn/statistics/statistics-get-detail-complex-statistics-by-user-id';
import { StatisticsGetDetailComplexStatisticsByUserId$Params } from '../fn/statistics/statistics-get-detail-complex-statistics-by-user-id';
import { statisticsGetDetailCurrentOrganizationComplexStatistics } from '../fn/statistics/statistics-get-detail-current-organization-complex-statistics';
import { StatisticsGetDetailCurrentOrganizationComplexStatistics$Params } from '../fn/statistics/statistics-get-detail-current-organization-complex-statistics';
import { statisticsGetMonthlyStatisticsByPartLengthByUserId } from '../fn/statistics/statistics-get-monthly-statistics-by-part-length-by-user-id';
import { StatisticsGetMonthlyStatisticsByPartLengthByUserId$Params } from '../fn/statistics/statistics-get-monthly-statistics-by-part-length-by-user-id';
import { statisticsGetOperatorDailyStatisticsByUserId } from '../fn/statistics/statistics-get-operator-daily-statistics-by-user-id';
import { StatisticsGetOperatorDailyStatisticsByUserId$Params } from '../fn/statistics/statistics-get-operator-daily-statistics-by-user-id';
import { statisticsGetOperatorMonthlyStatisticsByUserId } from '../fn/statistics/statistics-get-operator-monthly-statistics-by-user-id';
import { StatisticsGetOperatorMonthlyStatisticsByUserId$Params } from '../fn/statistics/statistics-get-operator-monthly-statistics-by-user-id';
import { statisticsGetSendStatusDailyStatisticsByUserId } from '../fn/statistics/statistics-get-send-status-daily-statistics-by-user-id';
import { StatisticsGetSendStatusDailyStatisticsByUserId$Params } from '../fn/statistics/statistics-get-send-status-daily-statistics-by-user-id';
import { statisticsGetSendStatusMonthlyStatisticsByUserId } from '../fn/statistics/statistics-get-send-status-monthly-statistics-by-user-id';
import { StatisticsGetSendStatusMonthlyStatisticsByUserId$Params } from '../fn/statistics/statistics-get-send-status-monthly-statistics-by-user-id';
import { statisticsGetSentCountDailyStatisticsByUserId } from '../fn/statistics/statistics-get-sent-count-daily-statistics-by-user-id';
import { StatisticsGetSentCountDailyStatisticsByUserId$Params } from '../fn/statistics/statistics-get-sent-count-daily-statistics-by-user-id';
import { statisticsGetSentCountMonthlyStatisticsByUserId } from '../fn/statistics/statistics-get-sent-count-monthly-statistics-by-user-id';
import { StatisticsGetSentCountMonthlyStatisticsByUserId$Params } from '../fn/statistics/statistics-get-sent-count-monthly-statistics-by-user-id';
import { statisticsGetTodayStatisticsByOperator } from '../fn/statistics/statistics-get-today-statistics-by-operator';
import { StatisticsGetTodayStatisticsByOperator$Params } from '../fn/statistics/statistics-get-today-statistics-by-operator';
import { statisticsGetTodayStatisticsByUserId } from '../fn/statistics/statistics-get-today-statistics-by-user-id';
import { StatisticsGetTodayStatisticsByUserId$Params } from '../fn/statistics/statistics-get-today-statistics-by-user-id';
import { statisticsGetUsersSentCountDailyStatistics } from '../fn/statistics/statistics-get-users-sent-count-daily-statistics';
import { StatisticsGetUsersSentCountDailyStatistics$Params } from '../fn/statistics/statistics-get-users-sent-count-daily-statistics';
import { statisticsGetUsersSentCountMonthlyStatistics } from '../fn/statistics/statistics-get-users-sent-count-monthly-statistics';
import { StatisticsGetUsersSentCountMonthlyStatistics$Params } from '../fn/statistics/statistics-get-users-sent-count-monthly-statistics';
import { statisticsRefreshStatistics } from '../fn/statistics/statistics-refresh-statistics';
import { StatisticsRefreshStatistics$Params } from '../fn/statistics/statistics-refresh-statistics';

@Injectable({ providedIn: 'root' })
export class StatisticsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `statisticsRefreshStatistics()` */
  static readonly StatisticsRefreshStatisticsPath = '/Statistics/RefreshStatistics';

  /**
   * بازیابی مجدد آمار در تاریخ مشخص.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsRefreshStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsRefreshStatistics$Response(params: StatisticsRefreshStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return statisticsRefreshStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * بازیابی مجدد آمار در تاریخ مشخص.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsRefreshStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsRefreshStatistics(params: StatisticsRefreshStatistics$Params, context?: HttpContext): Observable<CustomResult> {
    return this.statisticsRefreshStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentUserOperatorMonthlyStatistics()` */
  static readonly StatisticsGetCurrentUserOperatorMonthlyStatisticsPath = '/Statistics/GetCurrentUserOperatorMonthlyStatistics';

  /**
   * دریافت آمار ماهانه پیامک کاربر فعلی بر اساس اپراتورهای ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentUserOperatorMonthlyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserOperatorMonthlyStatistics$Response(params: StatisticsGetCurrentUserOperatorMonthlyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetOperatorMonthlyStatisticsResult>> {
    return statisticsGetCurrentUserOperatorMonthlyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ماهانه پیامک کاربر فعلی بر اساس اپراتورهای ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentUserOperatorMonthlyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserOperatorMonthlyStatistics(params: StatisticsGetCurrentUserOperatorMonthlyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetOperatorMonthlyStatisticsResult> {
    return this.statisticsGetCurrentUserOperatorMonthlyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetOperatorMonthlyStatisticsResult>): CustomResultOfListOfGetOperatorMonthlyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentUserOperatorDailyStatistics()` */
  static readonly StatisticsGetCurrentUserOperatorDailyStatisticsPath = '/Statistics/GetCurrentUserOperatorDailyStatistics';

  /**
   * دریافت آمار روزانه پیامک کاربر فعلی بر اساس اپراتورهای ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentUserOperatorDailyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserOperatorDailyStatistics$Response(params: StatisticsGetCurrentUserOperatorDailyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetOperatorDailyStatisticsResult>> {
    return statisticsGetCurrentUserOperatorDailyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار روزانه پیامک کاربر فعلی بر اساس اپراتورهای ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentUserOperatorDailyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserOperatorDailyStatistics(params: StatisticsGetCurrentUserOperatorDailyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetOperatorDailyStatisticsResult> {
    return this.statisticsGetCurrentUserOperatorDailyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetOperatorDailyStatisticsResult>): CustomResultOfListOfGetOperatorDailyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentOrganizationOperatorMonthlyStatistics()` */
  static readonly StatisticsGetCurrentOrganizationOperatorMonthlyStatisticsPath = '/Statistics/GetCurrentOrganizationOperatorMonthlyStatistics';

  /**
   * دریافت آمار ماهانه پیامک سازمان فعلی بر اساس اپراتورهای ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentOrganizationOperatorMonthlyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationOperatorMonthlyStatistics$Response(params: StatisticsGetCurrentOrganizationOperatorMonthlyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetOperatorMonthlyStatisticsResult>> {
    return statisticsGetCurrentOrganizationOperatorMonthlyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ماهانه پیامک سازمان فعلی بر اساس اپراتورهای ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentOrganizationOperatorMonthlyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationOperatorMonthlyStatistics(params: StatisticsGetCurrentOrganizationOperatorMonthlyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetOperatorMonthlyStatisticsResult> {
    return this.statisticsGetCurrentOrganizationOperatorMonthlyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetOperatorMonthlyStatisticsResult>): CustomResultOfListOfGetOperatorMonthlyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentOrganizationOperatorDailyStatistics()` */
  static readonly StatisticsGetCurrentOrganizationOperatorDailyStatisticsPath = '/Statistics/GetCurrentOrganizationOperatorDailyStatistics';

  /**
   * دریافت آمار روزانه پیامک سازمان فعلی بر اساس اپراتورهای ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentOrganizationOperatorDailyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationOperatorDailyStatistics$Response(params: StatisticsGetCurrentOrganizationOperatorDailyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetOperatorDailyStatisticsResult>> {
    return statisticsGetCurrentOrganizationOperatorDailyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار روزانه پیامک سازمان فعلی بر اساس اپراتورهای ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentOrganizationOperatorDailyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationOperatorDailyStatistics(params: StatisticsGetCurrentOrganizationOperatorDailyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetOperatorDailyStatisticsResult> {
    return this.statisticsGetCurrentOrganizationOperatorDailyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetOperatorDailyStatisticsResult>): CustomResultOfListOfGetOperatorDailyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetOperatorMonthlyStatisticsByUserId()` */
  static readonly StatisticsGetOperatorMonthlyStatisticsByUserIdPath = '/Statistics/GetOperatorMonthlyStatisticsByUserId';

  /**
   * دریافت آمار ماهانه پیامک کاربر بر اساس اپراتورهای ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetOperatorMonthlyStatisticsByUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetOperatorMonthlyStatisticsByUserId$Response(params: StatisticsGetOperatorMonthlyStatisticsByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetOperatorMonthlyStatisticsResult>> {
    return statisticsGetOperatorMonthlyStatisticsByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ماهانه پیامک کاربر بر اساس اپراتورهای ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetOperatorMonthlyStatisticsByUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetOperatorMonthlyStatisticsByUserId(params: StatisticsGetOperatorMonthlyStatisticsByUserId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetOperatorMonthlyStatisticsResult> {
    return this.statisticsGetOperatorMonthlyStatisticsByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetOperatorMonthlyStatisticsResult>): CustomResultOfListOfGetOperatorMonthlyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetOperatorDailyStatisticsByUserId()` */
  static readonly StatisticsGetOperatorDailyStatisticsByUserIdPath = '/Statistics/GetOperatorDailyStatisticsByUserId';

  /**
   * دریافت آمار روزانه پیامک کاربر بر اساس اپراتورهای ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetOperatorDailyStatisticsByUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetOperatorDailyStatisticsByUserId$Response(params: StatisticsGetOperatorDailyStatisticsByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetOperatorDailyStatisticsResult>> {
    return statisticsGetOperatorDailyStatisticsByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار روزانه پیامک کاربر بر اساس اپراتورهای ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetOperatorDailyStatisticsByUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetOperatorDailyStatisticsByUserId(params: StatisticsGetOperatorDailyStatisticsByUserId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetOperatorDailyStatisticsResult> {
    return this.statisticsGetOperatorDailyStatisticsByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetOperatorDailyStatisticsResult>): CustomResultOfListOfGetOperatorDailyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentUserSentCountDailyStatistics()` */
  static readonly StatisticsGetCurrentUserSentCountDailyStatisticsPath = '/Statistics/GetCurrentUserSentCountDailyStatistics';

  /**
   * دریافت تعداد کل پیامک های ارسال شده روزانه کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentUserSentCountDailyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserSentCountDailyStatistics$Response(params: StatisticsGetCurrentUserSentCountDailyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSendCountDailyStatisticsResult>> {
    return statisticsGetCurrentUserSentCountDailyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعداد کل پیامک های ارسال شده روزانه کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentUserSentCountDailyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserSentCountDailyStatistics(params: StatisticsGetCurrentUserSentCountDailyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSendCountDailyStatisticsResult> {
    return this.statisticsGetCurrentUserSentCountDailyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSendCountDailyStatisticsResult>): CustomResultOfListOfGetSendCountDailyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentUserSentCountMonthlyStatistics()` */
  static readonly StatisticsGetCurrentUserSentCountMonthlyStatisticsPath = '/Statistics/GetCurrentUserSentCountMonthlyStatistics';

  /**
   * دریافت تعداد کل پیامک های ارسال شده ماهانه کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentUserSentCountMonthlyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserSentCountMonthlyStatistics$Response(params: StatisticsGetCurrentUserSentCountMonthlyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSendCountMonthlyStatisticsResult>> {
    return statisticsGetCurrentUserSentCountMonthlyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعداد کل پیامک های ارسال شده ماهانه کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentUserSentCountMonthlyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserSentCountMonthlyStatistics(params: StatisticsGetCurrentUserSentCountMonthlyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSendCountMonthlyStatisticsResult> {
    return this.statisticsGetCurrentUserSentCountMonthlyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSendCountMonthlyStatisticsResult>): CustomResultOfListOfGetSendCountMonthlyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetUsersSentCountDailyStatistics()` */
  static readonly StatisticsGetUsersSentCountDailyStatisticsPath = '/Statistics/GetUsersSentCountDailyStatistics';

  /**
   * دریافت تعداد کل پیامک های ارسال شده روزانه کاربران.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetUsersSentCountDailyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetUsersSentCountDailyStatistics$Response(params: StatisticsGetUsersSentCountDailyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetUsersSentCountDailyStatisticsDto>> {
    return statisticsGetUsersSentCountDailyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعداد کل پیامک های ارسال شده روزانه کاربران.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetUsersSentCountDailyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetUsersSentCountDailyStatistics(params: StatisticsGetUsersSentCountDailyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetUsersSentCountDailyStatisticsDto> {
    return this.statisticsGetUsersSentCountDailyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetUsersSentCountDailyStatisticsDto>): CustomResultOfListOfGetUsersSentCountDailyStatisticsDto => r.body)
    );
  }

  /** Path part for operation `statisticsGetUsersSentCountMonthlyStatistics()` */
  static readonly StatisticsGetUsersSentCountMonthlyStatisticsPath = '/Statistics/GetUsersSentCountMonthlyStatistics';

  /**
   * دریافت تعداد کل پیامک های ارسال شده ماهانه کاربران.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetUsersSentCountMonthlyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetUsersSentCountMonthlyStatistics$Response(params: StatisticsGetUsersSentCountMonthlyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetUsersSentCountMonthlyStatisticsDto>> {
    return statisticsGetUsersSentCountMonthlyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعداد کل پیامک های ارسال شده ماهانه کاربران.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetUsersSentCountMonthlyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetUsersSentCountMonthlyStatistics(params: StatisticsGetUsersSentCountMonthlyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetUsersSentCountMonthlyStatisticsDto> {
    return this.statisticsGetUsersSentCountMonthlyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetUsersSentCountMonthlyStatisticsDto>): CustomResultOfListOfGetUsersSentCountMonthlyStatisticsDto => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentOrganizationSentCountDailyStatistics()` */
  static readonly StatisticsGetCurrentOrganizationSentCountDailyStatisticsPath = '/Statistics/GetCurrentOrganizationSentCountDailyStatistics';

  /**
   * دریافت تعداد کل پیامک های ارسال شده روزانه کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentOrganizationSentCountDailyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationSentCountDailyStatistics$Response(params: StatisticsGetCurrentOrganizationSentCountDailyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSendCountDailyStatisticsResult>> {
    return statisticsGetCurrentOrganizationSentCountDailyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعداد کل پیامک های ارسال شده روزانه کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentOrganizationSentCountDailyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationSentCountDailyStatistics(params: StatisticsGetCurrentOrganizationSentCountDailyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSendCountDailyStatisticsResult> {
    return this.statisticsGetCurrentOrganizationSentCountDailyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSendCountDailyStatisticsResult>): CustomResultOfListOfGetSendCountDailyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentOrganizationSentCountMonthlyStatistics()` */
  static readonly StatisticsGetCurrentOrganizationSentCountMonthlyStatisticsPath = '/Statistics/GetCurrentOrganizationSentCountMonthlyStatistics';

  /**
   * دریافت تعداد کل پیامک های ارسال شده ماهانه کاربر سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentOrganizationSentCountMonthlyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationSentCountMonthlyStatistics$Response(params: StatisticsGetCurrentOrganizationSentCountMonthlyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSendCountMonthlyStatisticsResult>> {
    return statisticsGetCurrentOrganizationSentCountMonthlyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعداد کل پیامک های ارسال شده ماهانه کاربر سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentOrganizationSentCountMonthlyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationSentCountMonthlyStatistics(params: StatisticsGetCurrentOrganizationSentCountMonthlyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSendCountMonthlyStatisticsResult> {
    return this.statisticsGetCurrentOrganizationSentCountMonthlyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSendCountMonthlyStatisticsResult>): CustomResultOfListOfGetSendCountMonthlyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetSentCountDailyStatisticsByUserId()` */
  static readonly StatisticsGetSentCountDailyStatisticsByUserIdPath = '/Statistics/GetSentCountDailyStatisticsByUserId';

  /**
   * دریافت تعداد کل پیامک های ارسال شده روزانه سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetSentCountDailyStatisticsByUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetSentCountDailyStatisticsByUserId$Response(params: StatisticsGetSentCountDailyStatisticsByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSendCountDailyStatisticsResult>> {
    return statisticsGetSentCountDailyStatisticsByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعداد کل پیامک های ارسال شده روزانه سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetSentCountDailyStatisticsByUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetSentCountDailyStatisticsByUserId(params: StatisticsGetSentCountDailyStatisticsByUserId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSendCountDailyStatisticsResult> {
    return this.statisticsGetSentCountDailyStatisticsByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSendCountDailyStatisticsResult>): CustomResultOfListOfGetSendCountDailyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetSentCountMonthlyStatisticsByUserId()` */
  static readonly StatisticsGetSentCountMonthlyStatisticsByUserIdPath = '/Statistics/GetSentCountMonthlyStatisticsByUserId';

  /**
   * دریافت تعداد کل پیامک های ارسال شده ماهانه کاربر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetSentCountMonthlyStatisticsByUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetSentCountMonthlyStatisticsByUserId$Response(params: StatisticsGetSentCountMonthlyStatisticsByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSendCountMonthlyStatisticsResult>> {
    return statisticsGetSentCountMonthlyStatisticsByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعداد کل پیامک های ارسال شده ماهانه کاربر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetSentCountMonthlyStatisticsByUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetSentCountMonthlyStatisticsByUserId(params: StatisticsGetSentCountMonthlyStatisticsByUserId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSendCountMonthlyStatisticsResult> {
    return this.statisticsGetSentCountMonthlyStatisticsByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSendCountMonthlyStatisticsResult>): CustomResultOfListOfGetSendCountMonthlyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentUserSendStatusDailyStatistics()` */
  static readonly StatisticsGetCurrentUserSendStatusDailyStatisticsPath = '/Statistics/GetCurrentUserSendStatusDailyStatistics';

  /**
   * دریافت آمار ارسال روزانه پیامک بر اساس وضعیت توسط کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentUserSendStatusDailyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserSendStatusDailyStatistics$Response(params: StatisticsGetCurrentUserSendStatusDailyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSendStatusDailyStatisticsResult>> {
    return statisticsGetCurrentUserSendStatusDailyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ارسال روزانه پیامک بر اساس وضعیت توسط کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentUserSendStatusDailyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserSendStatusDailyStatistics(params: StatisticsGetCurrentUserSendStatusDailyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSendStatusDailyStatisticsResult> {
    return this.statisticsGetCurrentUserSendStatusDailyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSendStatusDailyStatisticsResult>): CustomResultOfListOfGetSendStatusDailyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentUserSendStatusMonthlyStatistics()` */
  static readonly StatisticsGetCurrentUserSendStatusMonthlyStatisticsPath = '/Statistics/GetCurrentUserSendStatusMonthlyStatistics';

  /**
   * دریافت آمار ارسال ماهانه پیامک بر اساس وضعیت توسط کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentUserSendStatusMonthlyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserSendStatusMonthlyStatistics$Response(params: StatisticsGetCurrentUserSendStatusMonthlyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSendStatusMonthlyStatisticsResult>> {
    return statisticsGetCurrentUserSendStatusMonthlyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ارسال ماهانه پیامک بر اساس وضعیت توسط کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentUserSendStatusMonthlyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserSendStatusMonthlyStatistics(params: StatisticsGetCurrentUserSendStatusMonthlyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSendStatusMonthlyStatisticsResult> {
    return this.statisticsGetCurrentUserSendStatusMonthlyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSendStatusMonthlyStatisticsResult>): CustomResultOfListOfGetSendStatusMonthlyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetSendStatusDailyStatisticsByUserId()` */
  static readonly StatisticsGetSendStatusDailyStatisticsByUserIdPath = '/Statistics/GetSendStatusDailyStatisticsByUserId';

  /**
   * دریافت آمار ارسال روزانه پیامک بر اساس وضعیت توسط سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetSendStatusDailyStatisticsByUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetSendStatusDailyStatisticsByUserId$Response(params: StatisticsGetSendStatusDailyStatisticsByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSendStatusDailyStatisticsResult>> {
    return statisticsGetSendStatusDailyStatisticsByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ارسال روزانه پیامک بر اساس وضعیت توسط سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetSendStatusDailyStatisticsByUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetSendStatusDailyStatisticsByUserId(params: StatisticsGetSendStatusDailyStatisticsByUserId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSendStatusDailyStatisticsResult> {
    return this.statisticsGetSendStatusDailyStatisticsByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSendStatusDailyStatisticsResult>): CustomResultOfListOfGetSendStatusDailyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetSendStatusMonthlyStatisticsByUserId()` */
  static readonly StatisticsGetSendStatusMonthlyStatisticsByUserIdPath = '/Statistics/GetSendStatusMonthlyStatisticsByUserId';

  /**
   * دریافت آمار ارسال ماهانه پیامک بر اساس وضعیت توسط سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetSendStatusMonthlyStatisticsByUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetSendStatusMonthlyStatisticsByUserId$Response(params: StatisticsGetSendStatusMonthlyStatisticsByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSendStatusMonthlyStatisticsResult>> {
    return statisticsGetSendStatusMonthlyStatisticsByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ارسال ماهانه پیامک بر اساس وضعیت توسط سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetSendStatusMonthlyStatisticsByUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetSendStatusMonthlyStatisticsByUserId(params: StatisticsGetSendStatusMonthlyStatisticsByUserId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSendStatusMonthlyStatisticsResult> {
    return this.statisticsGetSendStatusMonthlyStatisticsByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSendStatusMonthlyStatisticsResult>): CustomResultOfListOfGetSendStatusMonthlyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentOrganizationSendStatusDailyStatistics()` */
  static readonly StatisticsGetCurrentOrganizationSendStatusDailyStatisticsPath = '/Statistics/GetCurrentOrganizationSendStatusDailyStatistics';

  /**
   * دریافت آمار ارسال روزانه پیامک بر اساس وضعیت توسط سازمان فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentOrganizationSendStatusDailyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationSendStatusDailyStatistics$Response(params: StatisticsGetCurrentOrganizationSendStatusDailyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSendStatusDailyStatisticsResult>> {
    return statisticsGetCurrentOrganizationSendStatusDailyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ارسال روزانه پیامک بر اساس وضعیت توسط سازمان فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentOrganizationSendStatusDailyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationSendStatusDailyStatistics(params: StatisticsGetCurrentOrganizationSendStatusDailyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSendStatusDailyStatisticsResult> {
    return this.statisticsGetCurrentOrganizationSendStatusDailyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSendStatusDailyStatisticsResult>): CustomResultOfListOfGetSendStatusDailyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentOrganizationSendStatusMonthlyStatistics()` */
  static readonly StatisticsGetCurrentOrganizationSendStatusMonthlyStatisticsPath = '/Statistics/GetCurrentOrganizationSendStatusMonthlyStatistics';

  /**
   * دریافت آمار ارسال ماهانه پیامک بر اساس وضعیت توسط سازمان فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentOrganizationSendStatusMonthlyStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationSendStatusMonthlyStatistics$Response(params: StatisticsGetCurrentOrganizationSendStatusMonthlyStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSendStatusMonthlyStatisticsResult>> {
    return statisticsGetCurrentOrganizationSendStatusMonthlyStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ارسال ماهانه پیامک بر اساس وضعیت توسط سازمان فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentOrganizationSendStatusMonthlyStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationSendStatusMonthlyStatistics(params: StatisticsGetCurrentOrganizationSendStatusMonthlyStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSendStatusMonthlyStatisticsResult> {
    return this.statisticsGetCurrentOrganizationSendStatusMonthlyStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSendStatusMonthlyStatisticsResult>): CustomResultOfListOfGetSendStatusMonthlyStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentUserComplexStatistics()` */
  static readonly StatisticsGetCurrentUserComplexStatisticsPath = '/Statistics/GetCurrentUserComplexStatistics';

  /**
   * دریافت آمار کلی پیامک های کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentUserComplexStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserComplexStatistics$Response(params: StatisticsGetCurrentUserComplexStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetComplexStatisticsResult>> {
    return statisticsGetCurrentUserComplexStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار کلی پیامک های کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentUserComplexStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserComplexStatistics(params: StatisticsGetCurrentUserComplexStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetComplexStatisticsResult> {
    return this.statisticsGetCurrentUserComplexStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetComplexStatisticsResult>): CustomResultOfListOfGetComplexStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetComplexStatisticsByUserId()` */
  static readonly StatisticsGetComplexStatisticsByUserIdPath = '/Statistics/GetComplexStatisticsByUserId';

  /**
   * دریافت آمار کلی پیامک های کاربر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetComplexStatisticsByUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetComplexStatisticsByUserId$Response(params: StatisticsGetComplexStatisticsByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetComplexStatisticsResult>> {
    return statisticsGetComplexStatisticsByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار کلی پیامک های کاربر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetComplexStatisticsByUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetComplexStatisticsByUserId(params: StatisticsGetComplexStatisticsByUserId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetComplexStatisticsResult> {
    return this.statisticsGetComplexStatisticsByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetComplexStatisticsResult>): CustomResultOfListOfGetComplexStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentOrganizationComplexStatistics()` */
  static readonly StatisticsGetCurrentOrganizationComplexStatisticsPath = '/Statistics/GetCurrentOrganizationComplexStatistics';

  /**
   * دریافت آمار کلی پیامک های سازمان فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentOrganizationComplexStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationComplexStatistics$Response(params: StatisticsGetCurrentOrganizationComplexStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetComplexStatisticsResult>> {
    return statisticsGetCurrentOrganizationComplexStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار کلی پیامک های سازمان فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentOrganizationComplexStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationComplexStatistics(params: StatisticsGetCurrentOrganizationComplexStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetComplexStatisticsResult> {
    return this.statisticsGetCurrentOrganizationComplexStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetComplexStatisticsResult>): CustomResultOfListOfGetComplexStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentUserDetailComplexStatistics()` */
  static readonly StatisticsGetCurrentUserDetailComplexStatisticsPath = '/Statistics/GetCurrentUserDetailComplexStatistics';

  /**
   * دریافت آمار جزئی پیامک های کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentUserDetailComplexStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserDetailComplexStatistics$Response(params: StatisticsGetCurrentUserDetailComplexStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetDetailComplexStatisticsResult>> {
    return statisticsGetCurrentUserDetailComplexStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار جزئی پیامک های کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentUserDetailComplexStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserDetailComplexStatistics(params: StatisticsGetCurrentUserDetailComplexStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetDetailComplexStatisticsResult> {
    return this.statisticsGetCurrentUserDetailComplexStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetDetailComplexStatisticsResult>): CustomResultOfListOfGetDetailComplexStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetDetailComplexStatisticsByUserId()` */
  static readonly StatisticsGetDetailComplexStatisticsByUserIdPath = '/Statistics/GetDetailComplexStatisticsByUserId';

  /**
   * دریافت آمار جزئی پیامک های کاربر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetDetailComplexStatisticsByUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetDetailComplexStatisticsByUserId$Response(params: StatisticsGetDetailComplexStatisticsByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetDetailComplexStatisticsResult>> {
    return statisticsGetDetailComplexStatisticsByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار جزئی پیامک های کاربر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetDetailComplexStatisticsByUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetDetailComplexStatisticsByUserId(params: StatisticsGetDetailComplexStatisticsByUserId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetDetailComplexStatisticsResult> {
    return this.statisticsGetDetailComplexStatisticsByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetDetailComplexStatisticsResult>): CustomResultOfListOfGetDetailComplexStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetDetailCurrentOrganizationComplexStatistics()` */
  static readonly StatisticsGetDetailCurrentOrganizationComplexStatisticsPath = '/Statistics/GetDetailCurrentOrganizationComplexStatistics';

  /**
   * دریافت آمار جزئی پیامک های سازمان فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetDetailCurrentOrganizationComplexStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetDetailCurrentOrganizationComplexStatistics$Response(params: StatisticsGetDetailCurrentOrganizationComplexStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetDetailComplexStatisticsResult>> {
    return statisticsGetDetailCurrentOrganizationComplexStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار جزئی پیامک های سازمان فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetDetailCurrentOrganizationComplexStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetDetailCurrentOrganizationComplexStatistics(params: StatisticsGetDetailCurrentOrganizationComplexStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetDetailComplexStatisticsResult> {
    return this.statisticsGetDetailCurrentOrganizationComplexStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetDetailComplexStatisticsResult>): CustomResultOfListOfGetDetailComplexStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentUserTodayStatistics()` */
  static readonly StatisticsGetCurrentUserTodayStatisticsPath = '/Statistics/GetCurrentUserTodayStatistics';

  /**
   * دریافت آمار ارسال روز جاری کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentUserTodayStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  statisticsGetCurrentUserTodayStatistics$Response(params?: StatisticsGetCurrentUserTodayStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetCurrentDayStatisticsResult>> {
    return statisticsGetCurrentUserTodayStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ارسال روز جاری کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentUserTodayStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  statisticsGetCurrentUserTodayStatistics(params?: StatisticsGetCurrentUserTodayStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetCurrentDayStatisticsResult> {
    return this.statisticsGetCurrentUserTodayStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetCurrentDayStatisticsResult>): CustomResultOfListOfGetCurrentDayStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentOrganizationTodayStatistics()` */
  static readonly StatisticsGetCurrentOrganizationTodayStatisticsPath = '/Statistics/GetCurrentOrganizationTodayStatistics';

  /**
   * دریافت آمار ارسال روز جاری سازمان فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentOrganizationTodayStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  statisticsGetCurrentOrganizationTodayStatistics$Response(params?: StatisticsGetCurrentOrganizationTodayStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetCurrentDayStatisticsResult>> {
    return statisticsGetCurrentOrganizationTodayStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ارسال روز جاری سازمان فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentOrganizationTodayStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  statisticsGetCurrentOrganizationTodayStatistics(params?: StatisticsGetCurrentOrganizationTodayStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetCurrentDayStatisticsResult> {
    return this.statisticsGetCurrentOrganizationTodayStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetCurrentDayStatisticsResult>): CustomResultOfListOfGetCurrentDayStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetTodayStatisticsByUserId()` */
  static readonly StatisticsGetTodayStatisticsByUserIdPath = '/Statistics/GetTodayStatisticsByUserId';

  /**
   * دریافت آمار ارسال روز جاری کاربر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetTodayStatisticsByUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetTodayStatisticsByUserId$Response(params: StatisticsGetTodayStatisticsByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetCurrentDayStatisticsResult>> {
    return statisticsGetTodayStatisticsByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ارسال روز جاری کاربر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetTodayStatisticsByUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetTodayStatisticsByUserId(params: StatisticsGetTodayStatisticsByUserId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetCurrentDayStatisticsResult> {
    return this.statisticsGetTodayStatisticsByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetCurrentDayStatisticsResult>): CustomResultOfListOfGetCurrentDayStatisticsResult => r.body)
    );
  }

  /** Path part for operation `statisticsGetTodayStatisticsByOperator()` */
  static readonly StatisticsGetTodayStatisticsByOperatorPath = '/Statistics/GetTodayStatisticsByOperator';

  /**
   * دریافت آمار ارسال روز جاری سازمان های زیرمجموعه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetTodayStatisticsByOperator()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetTodayStatisticsByOperator$Response(params: StatisticsGetTodayStatisticsByOperator$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetTodayStatisticsByOperatorDto>> {
    return statisticsGetTodayStatisticsByOperator(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ارسال روز جاری سازمان های زیرمجموعه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetTodayStatisticsByOperator$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetTodayStatisticsByOperator(params: StatisticsGetTodayStatisticsByOperator$Params, context?: HttpContext): Observable<CustomResultOfListOfGetTodayStatisticsByOperatorDto> {
    return this.statisticsGetTodayStatisticsByOperator$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetTodayStatisticsByOperatorDto>): CustomResultOfListOfGetTodayStatisticsByOperatorDto => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentUserMonthlyStatisticsByPartLength()` */
  static readonly StatisticsGetCurrentUserMonthlyStatisticsByPartLengthPath = '/Statistics/GetCurrentUserMonthlyStatisticsByPartLength';

  /**
   * دریافت آمار ماهانه کاربر فعلی بر اساس تعداد پارت و اپراتور ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentUserMonthlyStatisticsByPartLength()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserMonthlyStatisticsByPartLength$Response(params: StatisticsGetCurrentUserMonthlyStatisticsByPartLength$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetMonthlyStatisticsBySmsPartsDto>> {
    return statisticsGetCurrentUserMonthlyStatisticsByPartLength(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ماهانه کاربر فعلی بر اساس تعداد پارت و اپراتور ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentUserMonthlyStatisticsByPartLength$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserMonthlyStatisticsByPartLength(params: StatisticsGetCurrentUserMonthlyStatisticsByPartLength$Params, context?: HttpContext): Observable<CustomResultOfListOfGetMonthlyStatisticsBySmsPartsDto> {
    return this.statisticsGetCurrentUserMonthlyStatisticsByPartLength$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetMonthlyStatisticsBySmsPartsDto>): CustomResultOfListOfGetMonthlyStatisticsBySmsPartsDto => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentOrganizationMonthlyStatisticsByPartLength()` */
  static readonly StatisticsGetCurrentOrganizationMonthlyStatisticsByPartLengthPath = '/Statistics/GetCurrentOrganizationMonthlyStatisticsByPartLength';

  /**
   * دریافت آمار ماهانه سازمان فعلی بر اساس تعداد پارت و اپراتور ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentOrganizationMonthlyStatisticsByPartLength()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationMonthlyStatisticsByPartLength$Response(params: StatisticsGetCurrentOrganizationMonthlyStatisticsByPartLength$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetMonthlyStatisticsBySmsPartsDto>> {
    return statisticsGetCurrentOrganizationMonthlyStatisticsByPartLength(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ماهانه سازمان فعلی بر اساس تعداد پارت و اپراتور ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentOrganizationMonthlyStatisticsByPartLength$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationMonthlyStatisticsByPartLength(params: StatisticsGetCurrentOrganizationMonthlyStatisticsByPartLength$Params, context?: HttpContext): Observable<CustomResultOfListOfGetMonthlyStatisticsBySmsPartsDto> {
    return this.statisticsGetCurrentOrganizationMonthlyStatisticsByPartLength$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetMonthlyStatisticsBySmsPartsDto>): CustomResultOfListOfGetMonthlyStatisticsBySmsPartsDto => r.body)
    );
  }

  /** Path part for operation `statisticsGetMonthlyStatisticsByPartLengthByUserId()` */
  static readonly StatisticsGetMonthlyStatisticsByPartLengthByUserIdPath = '/Statistics/GetMonthlyStatisticsByPartLengthByUserId';

  /**
   * دریافت آمار ماهانه بر اساس تعداد پارت و اپراتور ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetMonthlyStatisticsByPartLengthByUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetMonthlyStatisticsByPartLengthByUserId$Response(params: StatisticsGetMonthlyStatisticsByPartLengthByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetMonthlyStatisticsBySmsPartsDto>> {
    return statisticsGetMonthlyStatisticsByPartLengthByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ماهانه بر اساس تعداد پارت و اپراتور ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetMonthlyStatisticsByPartLengthByUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetMonthlyStatisticsByPartLengthByUserId(params: StatisticsGetMonthlyStatisticsByPartLengthByUserId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetMonthlyStatisticsBySmsPartsDto> {
    return this.statisticsGetMonthlyStatisticsByPartLengthByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetMonthlyStatisticsBySmsPartsDto>): CustomResultOfListOfGetMonthlyStatisticsBySmsPartsDto => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentUserDailyStatisticsByPartLength()` */
  static readonly StatisticsGetCurrentUserDailyStatisticsByPartLengthPath = '/Statistics/GetCurrentUserDailyStatisticsByPartLength';

  /**
   * دریافت آمار روزانه کاربر فعلی بر اساس تعداد پارت و اپراتور ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentUserDailyStatisticsByPartLength()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserDailyStatisticsByPartLength$Response(params: StatisticsGetCurrentUserDailyStatisticsByPartLength$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetDailyStatisticsBySmsPartsDto>> {
    return statisticsGetCurrentUserDailyStatisticsByPartLength(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار روزانه کاربر فعلی بر اساس تعداد پارت و اپراتور ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentUserDailyStatisticsByPartLength$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentUserDailyStatisticsByPartLength(params: StatisticsGetCurrentUserDailyStatisticsByPartLength$Params, context?: HttpContext): Observable<CustomResultOfListOfGetDailyStatisticsBySmsPartsDto> {
    return this.statisticsGetCurrentUserDailyStatisticsByPartLength$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetDailyStatisticsBySmsPartsDto>): CustomResultOfListOfGetDailyStatisticsBySmsPartsDto => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentOrganizationDailyStatisticsByPartLength()` */
  static readonly StatisticsGetCurrentOrganizationDailyStatisticsByPartLengthPath = '/Statistics/GetCurrentOrganizationDailyStatisticsByPartLength';

  /**
   * دریافت آمار روزانه سازمان فعلی بر اساس تعداد پارت و اپراتور ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentOrganizationDailyStatisticsByPartLength()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationDailyStatisticsByPartLength$Response(params: StatisticsGetCurrentOrganizationDailyStatisticsByPartLength$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetDailyStatisticsBySmsPartsDto>> {
    return statisticsGetCurrentOrganizationDailyStatisticsByPartLength(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار روزانه سازمان فعلی بر اساس تعداد پارت و اپراتور ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentOrganizationDailyStatisticsByPartLength$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationDailyStatisticsByPartLength(params: StatisticsGetCurrentOrganizationDailyStatisticsByPartLength$Params, context?: HttpContext): Observable<CustomResultOfListOfGetDailyStatisticsBySmsPartsDto> {
    return this.statisticsGetCurrentOrganizationDailyStatisticsByPartLength$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetDailyStatisticsBySmsPartsDto>): CustomResultOfListOfGetDailyStatisticsBySmsPartsDto => r.body)
    );
  }

  /** Path part for operation `statisticsGetDailyStatisticsByPartLengthByUserId()` */
  static readonly StatisticsGetDailyStatisticsByPartLengthByUserIdPath = '/Statistics/GetDailyStatisticsByPartLengthByUserId';

  /**
   * دریافت آمار روزانه بر اساس تعداد پارت و اپراتور ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetDailyStatisticsByPartLengthByUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetDailyStatisticsByPartLengthByUserId$Response(params: StatisticsGetDailyStatisticsByPartLengthByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetDailyStatisticsBySmsPartsDto>> {
    return statisticsGetDailyStatisticsByPartLengthByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار روزانه بر اساس تعداد پارت و اپراتور ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetDailyStatisticsByPartLengthByUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetDailyStatisticsByPartLengthByUserId(params: StatisticsGetDailyStatisticsByPartLengthByUserId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetDailyStatisticsBySmsPartsDto> {
    return this.statisticsGetDailyStatisticsByPartLengthByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetDailyStatisticsBySmsPartsDto>): CustomResultOfListOfGetDailyStatisticsBySmsPartsDto => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentOrganizationMonthlyResellersStatistics()` */
  static readonly StatisticsGetCurrentOrganizationMonthlyResellersStatisticsPath = '/Statistics/GetCurrentOrganizationMonthlyResellersStatistics';

  /**
   * دریافت آمار ماهانه فروشندگان سازمان جاری.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentOrganizationMonthlyResellersStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationMonthlyResellersStatistics$Response(params: StatisticsGetCurrentOrganizationMonthlyResellersStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfCurrentOrganizationResellersStatisticsDto>> {
    return statisticsGetCurrentOrganizationMonthlyResellersStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ماهانه فروشندگان سازمان جاری.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentOrganizationMonthlyResellersStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationMonthlyResellersStatistics(params: StatisticsGetCurrentOrganizationMonthlyResellersStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfCurrentOrganizationResellersStatisticsDto> {
    return this.statisticsGetCurrentOrganizationMonthlyResellersStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfCurrentOrganizationResellersStatisticsDto>): CustomResultOfListOfCurrentOrganizationResellersStatisticsDto => r.body)
    );
  }

  /** Path part for operation `statisticsGetCurrentOrganizationDailyResellersStatistics()` */
  static readonly StatisticsGetCurrentOrganizationDailyResellersStatisticsPath = '/Statistics/GetCurrentOrganizationDailyResellersStatistics';

  /**
   * دریافت آمار روزانه فروشندگان سازمان جاری.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsGetCurrentOrganizationDailyResellersStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationDailyResellersStatistics$Response(params: StatisticsGetCurrentOrganizationDailyResellersStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfCurrentOrganizationDailyResellerStatisticsDto>> {
    return statisticsGetCurrentOrganizationDailyResellersStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار روزانه فروشندگان سازمان جاری.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsGetCurrentOrganizationDailyResellersStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statisticsGetCurrentOrganizationDailyResellersStatistics(params: StatisticsGetCurrentOrganizationDailyResellersStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfCurrentOrganizationDailyResellerStatisticsDto> {
    return this.statisticsGetCurrentOrganizationDailyResellersStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfCurrentOrganizationDailyResellerStatisticsDto>): CustomResultOfListOfCurrentOrganizationDailyResellerStatisticsDto => r.body)
    );
  }

}
